// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications .css-1aquho2-MuiTabs-indicator{background-color:#429eff}`, "",{"version":3,"sources":["webpack://./src/fsd/widgets/header/ui/Notifications/Notifications.scss"],"names":[],"mappings":"AACE,8CACE,wBAAA","sourcesContent":[".notifications {\n  .css-1aquho2-MuiTabs-indicator {\n    background-color: #429eff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
